// Badge.jsx
// Client: vmfive
// Version: 1.0.0

import './Badge.css';

export default function Badge({
  children,
  variant = 'default',
  className = '',
  ...rest
}) {
  return (
    <span className={`badge ${variant !== 'default' ? `badge-${variant}` : ''} ${className}`} {...rest}>
      {children}
    </span>
  );
}
